import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPenToSquare,
  faTrashAlt,
  faSquare1,
  faBoxesStacked,
  faPalletBoxes,
  faArrowTurnDownRight,
} from "@fortawesome/pro-regular-svg-icons";
import { toast } from "react-toastify";
import Swal from "sweetalert2";
import axiosConfig from "../../../services/Axios";
import ItemPackageBarCode from "./ItemPackageBarCode";
import ItemPackageInfos from "./ItemPackageInfos";

function ItemPackageRow({
  item,
  setItem,
  unitPackage,
  setDefinePackaging,
  definePackaging,
  isAdmin,
}) {
  const { t } = useTranslation();
  const handleDeleteItemPackage = (itemPackage) => {
    Swal.fire({
      text: t("settings.items.itemPackage.list.delete", {
        quantity: itemPackage.quantity,
      }),
      icon: "question",
      showCancelButton: true,
      confirmButtonText: t("global.btn.confirm_delete"),
      cancelButtonText: t("global.btn.cancel"),
      customClass: {
        actions: "gap-2 h-20",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        try {
          axiosConfig
            .delete(process.env.REACT_APP_API_URL + itemPackage["@id"])
            .then((response) => {
              if (response?.status === 204) {
                toast.success(t("settings.items.itemPackage.deleted"), {
                  theme: "colored",
                  hideProgressBar: true,
                });

                let newItem = { ...item };
                newItem.itemPackages = [];
                setItem(newItem);
              }
            });
        } catch (e) {
          if (
            e.response?.status !== 200 &&
            e.response?.data["hydra:description"]
          ) {
            toast.error(e.response?.data["hydra:description"]);
          }
        }
      }
    });
  };

  return (
    <div className="pl-2 pb-2">
      <div className="grid grid-cols-12 gap-3 mt-1 items-center">
        <div className="font-bold rounded text-center py-1 bg-bioport-orange text-white col-span-6">
          <FontAwesomeIcon icon={faSquare1} className="mr-2" />
          {t("itemPackages.unitCount", { count: unitPackage.quantity ?? 0 })}
        </div>
        <div className="text-center col-span-1">
          {unitPackage.barCode && (
            <ItemPackageBarCode itemPackage={unitPackage} />
          )}
        </div>
        <div className="text-center col-span-3"></div>
        {!definePackaging && (item.state === "draft" || isAdmin) && (
          <>
            <div className="text-center col-span-1">
              <div
                onClick={() => setDefinePackaging(true)}
                className="cursor-pointer text-bioport-blue "
              >
                <FontAwesomeIcon
                  icon={faPenToSquare}
                  className="transform hover:scale-110"
                />
              </div>
            </div>
            <div className="text-center col-span-1">
              <div
                onClick={() => handleDeleteItemPackage(unitPackage)}
                className="cursor-pointer text-red-500 "
              >
                <FontAwesomeIcon
                  icon={faTrashAlt}
                  className="transform hover:scale-110"
                />
              </div>
            </div>
          </>
        )}
      </div>
      {unitPackage.parentPackage && (
        <>
          <div className="grid grid-cols-12 gap-3 mt-2 items-center">
            <div className="font-bold text-center">
              <FontAwesomeIcon icon={faArrowTurnDownRight} className="mr-2" />
            </div>
            <div className="font-bold rounded text-center py-1 bg-bioport-orange text-white col-span-4">
              <FontAwesomeIcon icon={faBoxesStacked} className="mr-2" />
              {t("itemPackages.boxCount", {
                count: unitPackage.parentPackage.quantity ?? 0,
              })}
            </div>
            <div className="text-center col-start-7 col-span-1">
              {unitPackage.parentPackage.barCode && (
                <ItemPackageBarCode itemPackage={unitPackage.parentPackage} />
              )}
            </div>
            <div className="col-span-4">
              <ItemPackageInfos itemPackage={unitPackage.parentPackage} />
            </div>
          </div>

          {unitPackage.parentPackage.parentPackage && (
            <div className="grid grid-cols-12 gap-3 mt-2 items-center">
              <div className="font-bold col-span-2 text-right">
                <FontAwesomeIcon icon={faArrowTurnDownRight} className="mr-2" />
              </div>
              <div className="font-bold rounded text-center py-1 bg-bioport-orange text-white col-span-2">
                <FontAwesomeIcon icon={faPalletBoxes} className="mr-2" />
                {t("itemPackages.palletCount", {
                  count: unitPackage.parentPackage.parentPackage.quantity ?? 0,
                })}
              </div>
              <div className="text-center col-start-7 col-span-1">
                {unitPackage.parentPackage.parentPackage.barCode && (
                  <ItemPackageBarCode
                    itemPackage={unitPackage.parentPackage.parentPackage}
                  />
                )}
              </div>
              <div className="col-span-4">
                <ItemPackageInfos
                  itemPackage={unitPackage.parentPackage.parentPackage}
                />
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
}

export default ItemPackageRow;
